import Section from 'components/Section'
import { HeroForm } from 'components/HeroForm'
import { useMemoizedContentGetter } from 'utils/contentful'


function ProductHeroModule({
  title,
  subtitle,
  breadcrumb,
  image,
  sliderStatsTitle,
  sliderQuestion,
  sliderProps,
  isMobileUA = true,
  hasPhone = false,
  phoneWrapper,
  disclosuresLink,
}) {
  return (
    <Section
      className={''}
      childContainerClassName={'p-0 group-data-[narrow="true"]:px-0 lg:px-8 lg:pt-8 lg:pb-16'}
    >
      <HeroForm
        title={title?.textContent}
        subtitle={subtitle?.textContent}
        breadcrumb={breadcrumb?.textContent}
        image={image?.mediaContent}
        mobileImage={image?.mobileMediaContent}
        alt={image?.mediaAltText}
        sliderStatsTitle={sliderStatsTitle?.textContent}
        sliderQuestion={sliderQuestion?.textContent}
        sliderProps={sliderProps?.jsonContent}
        isMobileUA={isMobileUA}
        hasPhone={hasPhone}
        phoneWrapper={phoneWrapper}
        disclosuresLink={disclosuresLink}
      />
    </Section>
  )
}

function ProductHero({ content }) {
  const memoizedContent = useMemoizedContentGetter(content, [
    'title',
    'subtitle',
    'breadcrumb',
    'image',
    'sliderStatsTitle',
    'sliderProps',
    'sliderQuestion',
    'disclosuresLink',
  ])


  const hasPhone = content?.fields?.additionalConfiguration?.fields?.jsonContent?.phone
  const phoneWrapper = content?.fields?.additionalConfiguration?.fields?.jsonContent?.phoneWrapper
  const {
    title,
    subtitle,
    breadcrumb,
    image,
    sliderStatsTitle,
    sliderProps,
    sliderQuestion,
    disclosuresLink,
  } = memoizedContent

  return (
    <ProductHeroModule
      title={title}
      subtitle={subtitle}
      breadcrumb={breadcrumb}
      image={image}
      sliderStatsTitle={sliderStatsTitle}
      sliderQuestion={sliderQuestion}
      sliderProps={sliderProps}
      isMobileUA={content?.isMobileUA}
      hasPhone={hasPhone}
      phoneWrapper={phoneWrapper}
      disclosuresLink={disclosuresLink}
    />
  )
}
export { ProductHero, ProductHeroModule }
export default ProductHero
